import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import firebase from "firebase/app";
import "./i18n";

const firebaseConfig = {
  apiKey: "AIzaSyCCxncJ78B9C7LdI2B2v7DnjkoGBwtA8-M",
  authDomain: "yazbie.com",
  databaseURL: "https://epiknovels.firebaseio.com/",
  projectId: "epiknovels",
  storageBucket: "epiknovels.appspot.com",
  messagingSenderId: "676586694944",
  appId: "1:676586694944:web:4540ba9624f02b5f200f45",
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
// firebase.analytics();

ReactDOM.render(<App />, document.getElementById("root"));
